import fetch from '@/utils/fetch';
//权限信息列表接口
export function permissionList(params) {
  return fetch({
    url: '/permission/list',
    method: 'get',
    params
  });
}
//权限信息-单个添加
export function permissionAdd(obj) {
  return fetch({
    url: '/permission/add',
    method: 'post',
    data: obj
  });
}
//权限信息-单个修改
export function permissionUpdate(obj) {
  return fetch({
    url: '/permission/update/',
    method: 'post',
    data: obj
  });
}
//权限信息-单个删除
export function permissionrRemove(data) {
  return fetch({
    url: '/permission/remove',
    method: 'post',
    data
  });
}
//权限组列表接口
export function permissionGroupList(params) {
  return fetch({
    url: '/permissionGroup/list',
    method: 'get',
    params
  });
}
//getGroupTree
//权限组列表接口
export function permissionGroupTree(params) {
  return fetch({
    url: '/permissionGroup/getGroupTree',
    method: 'get',
    params
  });
}
//permissionGroupAdd 添加单个权限组
export function permissionGroupAdd(obj) {
  return fetch({
    url: '/permissionGroup/add',
    method: 'post',
    data: obj
  });
}
//权限组信息-单个修改
export function permissionGroupUpdate(obj) {
  return fetch({
    url: '/permissionGroup/update',
    method: 'post',
    data: obj
  });
}
//权限组信息-单个删除
export function permissionGroupRemove(data) {
  return fetch({
    url: '/permissionGroup/remove',
    method: 'post',
    data
  });
}
//获取用户路由信息
export function permissionGroupgetRouters(params) {
  return fetch({
    url: '/permissionGroup/getRouterInfo',
    method: 'get',
    params
  });
}


//获取单个权限组详情信息
export function permissionGroupDetil(id) {
  return fetch({
    url: '/permissionGroup/' + id,
    method: 'get', 
  });
}
//获取按钮权限
export function permissionGroupBtn(id) {
  return fetch({
    url: /permissionGroup/+ id +'/SubFunctionCode',
    method: 'get', 
  });
}


// WEBPACK FOOTER //
// ./src/api/permission.js